<div class="dialogue-content">
    <div class="mat-dialogue-header">
        <h4>Session Pass</h4>
        <button type="button" class="btn-close" aria-label="Close" (click)="cancel()"></button>
    </div>
    <mat-dialog-content class="pt-0">
        <div class="passes-box ">
            <h3 class="title text-center">Passes</h3>
            <div class="btn-group row w-100 mx-auto ">
                <label class="btn btn-secondary mb-3 ms-9"
                    [ngClass]="{'selected-box': passes.paymentPassId === selectedPassId}"
                    *ngFor="let passes of passList">
                    <input type="radio" [(ngModel)]="selectedPassId" name="passRadioGroup"
                        [value]="passes.paymentPassId" class="float-end ms-3 mt-1"
                        (click)="showDetailsForPass(passes.paymentPassId)" />
                    <div class="passes-details d-flex justify-content-between">
                        <p class="mb-0">{{passes.name}}</p>
                        <div class="passes-amount">
                            <span>{{currency.pound}}{{passes.amount}}</span>
                        </div>
                    </div>
                    <div class="details-attend mt-2 text-start"
                        *ngIf="selectedPassId === passes.paymentPassId && showDetails && !(passes.passesUsed > 0 || passes.passesLeft > 0)">
                        <hr class="divider">
                        <div class="passes-details d-flex justify-content-between mb-2">
                        </div>
                        <div class="pass-type">
                            <label>Passes :</label>
                            <i class="fa fa-credit-card"></i>
                            <span>{{passes.passType==="Unlimited" ? "Unlimited" : passes.totalNoOfSession }}</span>
                        </div>
                        <div class="expiry-date">
                            <label>Expire On :</label>
                            <i class="fa-regular fa-calendar-days"></i>
                            <span [innerHTML]="passes.expiryDate | ordinalDate : passes.expiryDate"></span>
                        </div>
                    </div>
                </label>
                <div *ngIf="passList.length === 0" class="mt-3 mb-2 text-center">
                    <p>No pass record found!</p>
                </div>
            </div>
        </div>

        <div class="mt-3 w-100">
            <button class="btn btn-primary w-100" title="Add New Order" [disabled]="selectedPassId == null || selectedPassId == undefined" (click)="addToCart()">
                Add
            </button>
        </div>
        <div class="mt-3 text-center">
            <button class="btn btn-primary-outline previous-btn" (click)="cancel()" title="">
                Previous
            </button>
        </div>
    </mat-dialog-content>
</div>